const responses = {
  en: {
    greetings: ['hello', 'hi', 'hey', 'good morning', 'good afternoon', 'good evening'],
    goodbyes: ['goodbye', 'bye', 'see you', 'later'],
    thankYous: ['thank you', 'thanks', 'thank you very much'],
    responses: {
      greeting: 'Hello! How can I help you today?',
      goodbye: 'Bye!',
      thankYou: "You're welcome! Can I help you in any other way?",
    },
  },
  dutch: {
    greetings: ['hallo', 'hoi', 'goedemorgen', 'goedemiddag', 'goedenavond'],
    goodbyes: ['tot ziens', 'doei', 'later', 'vaarwel'],
    thankYous: ['dank je', 'bedankt', 'dank u wel'],
    responses: {
      greeting: 'Hallo! Hoe kan ik je vandaag helpen?',
      goodbye: 'Doei!',
      thankYou: 'Graag gedaan! Kan ik je nog ergens anders mee helpen?',
    },
  },
  arabic: {
    greetings: ['مرحبا', 'صباح الخير', 'مساء الخير'],
    goodbyes: ['وداعا', 'مع السلامة', 'الى اللقاء', 'اراك لاحقا'],
    thankYous: ['شكرا', 'شكرا جزيلا'],
    responses: {
      greeting: 'مرحبا! كيف يمكنني مساعدتك اليوم؟',
      goodbye: 'مع السلامة!',
      thankYou: 'شكرا! هل يمكنني مساعدتك في شيء آخر؟',
    },
  },
};

export default responses;
